"use strict";
export var LiquiditySource = /* @__PURE__ */ ((LiquiditySource2) => {
  LiquiditySource2["SUSHISWAP"] = "Sushiswap";
  LiquiditySource2["V2"] = "V2";
  LiquiditySource2["V3"] = "V3";
  return LiquiditySource2;
})(LiquiditySource || {});
export var FeePoolSelectAction = /* @__PURE__ */ ((FeePoolSelectAction2) => {
  FeePoolSelectAction2["MANUAL"] = "Manual";
  FeePoolSelectAction2["RECOMMENDED"] = "Recommended";
  FeePoolSelectAction2["SEARCH"] = "Search";
  return FeePoolSelectAction2;
})(FeePoolSelectAction || {});
